import { useQuery } from "../_app/lib/query";
import { AccountLevel } from "../account/utils";
import { useHubUserExist } from "../user/hooks";
import { useContextProvider } from "../context/providers/ContextProvider";
import { getMyUserLevelType } from "./api";

export function useMyUserLevelType(options = {}) {
  const { data: userExists } = useHubUserExist();
  return useQuery({
    queryKey: ["myUserType", { exists: userExists }],
    queryFn: () => getMyUserLevelType(),
    enabled: Boolean(userExists),
    ...options,
  });
}

export function useHasAccountLevelAccess(level?: AccountLevel) {
  const { contextData } = useContextProvider();
  if (!level) return true;
  return (contextData?.level?.id || 0) <= level.id;
}

export function useContextUserLevelPrefix() {
  const { contextData } = useContextProvider();
  return contextData?.level?.label || "";
}
